import { all, takeEvery, select, put, call } from 'redux-saga/effects';
import actions from "./actions";
import { getDocuments, getDocument } from "../../services/documents.service";
import {ReducerType} from "../reducer.type";
import { ClientInterface, ClientWorkspace } from '../client/client.type';
import { AxiosResponse } from 'axios';

const getWorkspace = (state: ReducerType) => state.client.owner.workspace;
const getClient = (state: ReducerType) => state.client.owner;

export function* GET_ALL_CLIENT_DOCUMENTS() {
    const workspace: ClientWorkspace = yield select(getWorkspace);
    const client: ClientInterface = yield select(getClient);
    if (workspace && client) {
        try {
            const response: AxiosResponse<any> = yield call(
              getDocuments,
              workspace.uuid,
              client.uuid
            );
            if (response.data) {
                yield put({
                    type: actions.SET_DOCUMENTS,
                    payload: response.data
                })
            }
        } catch (e) {

        }
    }

}

export function* GET_CLIENT_DOCUMENT(action: {payload: string, type: string}){
    const workspace: ClientWorkspace = yield select(getWorkspace);
    const client: ClientInterface = yield select(getClient);
    const documentUuid = action.payload;
    try{
        const response: AxiosResponse<any> = yield call(
          getDocument,
          workspace.uuid,
          client.uuid,
          documentUuid
        );
        if(response){
            yield put({
                type: actions.SET_DOCUMENT,
                payload: response.data
            })
        }
    }
        catch (e) {

        }
}

export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_DOCUMENTS, GET_ALL_CLIENT_DOCUMENTS),
        takeEvery(actions.GET_DOCUMENT, GET_CLIENT_DOCUMENT)
    ])
}
